<template>
  <div id="page-wrapper" v-if="loggedIn">
    <div class="container">
      <div class="row page-section">
        <!-- {{selectedServiceProviderQuestion}} -->
        <section class="bill-payment col-md-12 col-xs-12">
          <input
            type="text"
            placeholder="State"
            class="bill-payment__input__select"
            v-model="selectedState"
            @click="selectState"
            autofocus
          />
          <input
            type="text"
            placeholder="Service Provider"
            class="bill-payment__input__select"
            v-model="selectedServiceProvider"
            @click="selectServiceProvider"
            :disabled="!selectedState"
          />

          <div v-for="(question, index) in selectedServiceProviderQuestion" :key="index">
            <input
              type="number"
              :placeholder="question.questionLabel"
              class="bill-payment__input"
              v-model="selectedCustomer[index]"
              :maxlength="question.maxLength"
              v-if="question.numeric"
            />
            <input
              type="text"
              :placeholder="question.questionLabel"
              class="bill-payment__input"
              v-model="selectedCustomer[index]"
              :maxlength="question.maxLength"
              v-else
            />
          </div>
          <p class="text-error text-center mt-30" v-if="pageError">{{ pageError }}</p>
          <!--p class="text-red text-center" v-if="pageMessage">{{pageMessage}}</p-->

          <ActionButton
            :disabled="!(selectedState && selectedServiceProvider)"
            @click="fetchBill"
            title="Fetch Bill"
          />
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ActionButton from "@/components/ActionButton/index";

export default {
  name: "FetchBillWeb",
  data() {
    return {
      query: {},
      payment_mode: "prepaid",
      pageError: "",
      selectedCustomer: [],
      validationTextMobile: "",
      validMobile: false,
      operatorsLoaded: false,
      paymentMethod: [
        { displayName: "Prepaid", methodKey: "prepaid" },
        { displayName: "Postpaid", methodKey: "postpaid" }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "loggedIn",
      "selectedState",
      "selectedServiceProvider",
      "selectedServiceProviderQuestion",
      "selectedAccountNumber"
    ])
  },
  mounted() {},
  methods: {
    selectState() {
      this.$router.push({ name: "StateWeb" });
    },
    selectServiceProvider() {
      this.$router.push({ name: "BoardWeb" });
    },
    fetchBill() {
      this.pageError = "";
      if (
        this.selectedState &&
        this.selectedServiceProvider &&
        this.selectedCustomer.length > 0
      ) {
        let questionLabelValue = this.selectedCustomer;
        let questionLabel = [];
        this.selectedServiceProviderQuestion.forEach(function(item, key) {
          let questionLabelItem = {};
          questionLabelItem.questionLabel = item.questionLabel;
          questionLabelItem.value = questionLabelValue[key];
          questionLabel.push(questionLabelItem);
        });
        this.query = {
          deviceInfo: {
            ip: "103.82.208.39",
            initiatingChannel: "MOBB",
            imei: "843843843843",
            os: "sfdfkfdfdk",
            appName: "fdkfdfdkfd",
            mac: "3C-97-0E-E4-1D-25",
            terminalId: "9911100048",
            geoCode: "77.1801,8.2784",
            ifsc: ""
          },
          transactionInfo: {
            name: this.selectedServiceProvider,
            questions: questionLabel
          }
        };
        if (this.selectedBillFetch) {
          this.$store.dispatch("storeMixpanelEvent", {
            eventName: "BP_BILL_FETCH_STARTED",
            propertyName: "BILL_TYPE",
            propertyValue: this.$route.params.category.toUpperCase()
          });
          this.$store.dispatch("storeMixpanelEvent", {
            eventName: "BP_BILL_FETCH_STARTED",
            propertyName: "STATE",
            propertyValue: this.selectedState
          });
          this.$store.dispatch("storeMixpanelEvent", {
            eventName: "BP_BILL_FETCH_STARTED",
            propertyName: "PROVIDER",
            propertyValue: this.selectedServiceProvider
          });
          this.pageError = "";
          this.$store
            .dispatch("getBill", {
              params: this.query
            })
            .then(response => {
              if (response.responseInfo.responseMessage === "Success") {
                this.$store.dispatch("storeMixpanelEvent", {
                  eventName: "BP_BILL_FETCH_RESULT",
                  propertyName: "STATUS",
                  propertyValue: "SUCCESS"
                });
                this.$router.push({
                  name: "BillWeb",
                  params: {
                    category: this.$route.params.category,
                    billResponse: response,
                    queryData: this.query
                  }
                });
              } else if (response.responseInfo.responseMessage === "Fail") {
                this.$store.dispatch("storeMixpanelEvent", {
                  eventName: "BP_BILL_FETCH_RESULT",
                  propertyName: "STATUS",
                  propertyValue: "FAILURE"
                });
                this.$store.dispatch("storeMixpanelEvent", {
                  eventName: "BP_BILL_FETCH_RESULT",
                  propertyName: "REASON",
                  propertyValue: response.responseInfo.responseDescription
                });
              }
            })
            .catch(err => {
              this.$store.dispatch("storeMixpanelEvent", {
                eventName: "BP_BILL_FETCH_RESULT",
                propertyName: "STATUS",
                propertyValue: "FAILURE"
              });
              this.$store.dispatch("storeMixpanelEvent", {
                eventName: "BP_BILL_FETCH_RESULT",
                propertyName: "REASON",
                propertyValue: "Failed due to unknown reason"
              });
            });
        } else {
          this.$router.push({
            name: "BillWeb",
            params: {
              category: this.$route.params.category,
              queryData: this.query
            }
          });
        }
      } else {
        this.pageError = "Please fill all the field.";
      }
    }
  }
};
</script>
<style lang="css" scoped>
.content-wrap {
  background: #f5f6f7;
}
</style>



// WEBPACK FOOTER //
// src/components/FetchBillWeb.vue